import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Expand = (props) => (
  <Icon viewBox="0 0 13 13" {...props}>
    <g>
      <title>Combined Shape</title>
      <path d="M6 6V.5a.5.5 0 1 1 1 0V6h5.5a.5.5 0 1 1 0 1H7v5.5a.5.5 0 1 1-1 0V7H.5a.5.5 0 1 1 0-1H6z" fill="currentColor" fillRule="nonzero"
      />
    </g>
  </Icon>
);
/*eslint-enable */

export default Expand;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Expand.js